import React from 'react';
import PropTypes from 'prop-types';

export const BtmLayout = ({ children }) => {
  return (<div id="BrandsThatMatter__Application">{children}</div>)
};

BtmLayout.propTypes = {
  children: PropTypes.any
}